import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue';
import { _EDIT } from '@shell/config/query-params';
import { TYPES } from '@shell/models/secret';
import { SECRET } from '@shell/config/types';
import { PaginationParamFilter } from '@shell/types/store/pagination.types';
import ResourceLabeledSelect from '@shell/components/form/ResourceLabeledSelect.vue';

interface Secret {
  id?: string;
  name: string;
  namespace: string;
  _type: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FleetSecretSelector',
  props: {
  value: {
    type:     Object,
    required: true,
  },
  namespace: {
    type:     String,
    required: true,
  },
  inStore: {
    type:    String,
    default: 'management',
  },
  mode: {
    type:    String,
    default: _EDIT
  },
  label: {
    type:    String,
    default: '',
  },
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const types = computed<string[]>(() => Object.values(TYPES));

const secrets = ref<Secret[]>([]);

const allSecretsSettings = {
  updateResources: (secretsList: Secret[]) => {
    const allSecretsInNamespace = secretsList.filter((secret) => types.value.includes(secret._type) && secret.namespace === props.namespace);
    const mappedSecrets = mapSecrets(allSecretsInNamespace.sort((a, b) => a.name.localeCompare(b.name)));

    secrets.value = allSecretsInNamespace;

    return mappedSecrets;
  }
};

const paginateSecretsSetting = {
  requestSettings: paginatePageOptions,
  updateResources: (secretsList: Secret[]) => {
    const mappedSecrets = mapSecrets(secretsList);

    secrets.value = secretsList;

    return mappedSecrets;
  }
};

function mapSecrets(secretsList: Secret[]) {
  return secretsList.reduce<{ label: string; value: string }[]>((res, s) => {
    if (s.id) {
      res.push({ label: s.name, value: s.name });
    } else {
      res.push(s as any);
    }

    return res;
  }, []);
}

function update(value: any) {
  emit('update:value', value);
}

function paginatePageOptions(opts: any) {
  const { opts: { filter } } = opts;

  const filters = !!filter ? [PaginationParamFilter.createSingleField({
    field: 'metadata.name', value: filter, exact: false, equals: true
  })] : [];

  filters.push(
    PaginationParamFilter.createSingleField({ field: 'metadata.namespace', value: props.namespace }),
    PaginationParamFilter.createMultipleFields(types.value.map((t) => ({
      field:  'metadata.fields.1',
      equals: true,
      exact:  true,
      value:  t
    })))
  );

  return {
    ...opts,
    filters,
    groupByNamespace: false,
    classify:         true,
    sort:             [{ asc: true, field: 'metadata.name' }],
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResourceLabeledSelect, {
    key: __props.namespace,
    value: __props.value,
    label: __props.label || _ctx.t('fleet.secrets.label'),
    mode: __props.mode,
    "resource-type": _unref(SECRET),
    loading: _ctx.$fetchState.pending,
    "in-store": __props.inStore,
    "paginated-resource-settings": paginateSecretsSetting,
    "all-resources-settings": allSecretsSettings,
    multiple: true,
    "onUpdate:value": update
  }, null, 8, ["value", "label", "mode", "resource-type", "loading", "in-store"]))
}
}

})